import common from 'constants/common';

const PCMIndicator = () => (
  <div
    style={{ backgroundColor: common.consentStatus.confirmed }}
    className="ccm-status-indicator"
  >
    PCM
  </div>
);

export default PCMIndicator;
